__webpack_require__.p = "/skote/react-ts/v-rtl/";